(function() {
  // Note: we are checking support for IntersectionObserver in the rsp template.
  // current browser support: https://caniuse.com/#search=intersection
  // if the browser does *not* support it we load the polyfill asynchronously
  // and then run this code after it's loaded successfully

  window.addEventListener('load', function(e) {
    if ( window.scrollY > 0  || window.pageYOffset > 0 ) {
      // console.log('Scroll position restored. Load all our lazy images');
      var lazyGroupData = fetchLazyGroupData();
      var elements = [];
      lazyGroupData.forEach(function(group) {
        group.els.forEach(function (element) {
          lazyLoad(element);
        });
      });
    }

    else {
      // console.log('load lazy images immediately before they come into the viewport');
      initIObserver();
    }
  });


  // document.querySelectorAll returns a nodeList rather than an array.
  // this little util function takes care of that
  function arrayFromQSA(selector) {
    var arr = [];
    var nodes =document.querySelectorAll(selector)

    for (var i = 0, l = nodes.length; i < l; i++ ) {
      arr.push(nodes[i]);
    }

    return arr;
  }

  function lazyLoad(el) {
    // console.log('lazyLoad() called with', el);

    if ( el && el.dataset.lazyImg ) {
      el.src = el.dataset.lazyImg;
    }

    else if ( el && el.dataset.lazyBg ) {
      el.style.backgroundImage = el.dataset.lazyBg;
    }
  }


  function fetchLazyGroups(items) {
    var lazyGroups = [];

    items.forEach(function(item) {
      var group = item.dataset.lazyGroup;
      if ( lazyGroups.indexOf(group) === -1 ) {
        lazyGroups.push(group);
      }
    });

    return lazyGroups;

  }
  function fetchLazyGroupData() {
    var items = arrayFromQSA('[data-lazy-group]');
    var groups = fetchLazyGroups(items);
    var lazyGroupData = [];

    groups.forEach(function(g) {
      var name = 'group_' + g;
      var els = items.filter(function(el) {
        return el.dataset.lazyGroup === g;
      });
      lazyGroupData.push({ name: name, els: els });
    });

    return lazyGroupData;
  }


  function initIObserver() {

    var options = {
      // we set root to null to use the browser viewport
      root: null,
      rootMargin: '0px',
      threshold: 1
    };

    var observer = new IntersectionObserver(cb, options);
    var lazyGroupIdx = 0;
    var lazyGroupData = fetchLazyGroupData();
    // sentinels are set in the DOM by giving an element a class of
    // js-sentinel.
    var sentinel = {
      el: null,
      set: function(element) {
        this.el = element;
        observer.observe(this.el);
      },
      unset: function() {
        if ( !this.el ) {
          return;
        }
        observer.unobserve(this.el);
        this.el.classList.remove('js-sentinel');
        this.el = null;
      }
    }

    function updateSentinel() {
      var el = document.querySelector('.js-sentinel');

      if ( el ) {
        el && sentinel.set(el);
        // console.log('updating sentinel to:', el.className);
      }
    }

    // grab the first sentinel
    updateSentinel();


    // group the items to lazy load using the lazy-group data attribute
    // e.g. <img data-lazy-group="1"
    //
    // specify the image to lazy load with the lazy-img data attribute
    // e.g. data-lazy-img="/path/to/image"
    //
    // specify the backround-image to lazy load with the lazy-bg data attribute
    // e.g. data-lazy-bg="url(/path/to/image)"
    //

    function cb(entries) {
      entries.forEach(function(entry) {
        if ( entry.isIntersecting && lazyGroupIdx < lazyGroupData.length ) {
          sentinel.unset();
          // console.log('Lazy-loading group:' + lazyGroupData[lazyGroupIdx]);
          lazyGroupData[lazyGroupIdx].els.forEach(function(el) {
            lazyLoad(el);
            var lazyResource = el.dataset.lazyBg || el.dataset.lazyImg;
            // console.log('Lazily loading:' + lazyResource);
          });
          lazyGroupIdx++;
          updateSentinel();
        }
      });
    }
  }

})();
